import { Page, Card, BlockStack, DescriptionList, Text } from '@shopify/polaris';
import { useResource } from '../../../shared/hooks/useResource';
import { LoadingState } from '../../../shared/components/LoadingState';
import { ErrorBanner } from '../../../shared/components/ErrorBanner';
import { TntTestConnectionCard } from './TntTestConnectionCard';
import { getTntSettings } from './api';

export function TntSettingsPage(): JSX.Element {
  const query = useResource(['tnt-settings'], getTntSettings);

  return (
    <Page title="TNT settings" subtitle="Carrier credentials (read-only)">
      <BlockStack gap="400">
        {query.error ? <ErrorBanner error={query.error} /> : null}
        <Card>
          <BlockStack gap="200">
            <Text as="h2" variant="headingMd">Connection settings</Text>
            {query.isLoading ? <LoadingState message="Loading..." /> : null}
            {query.data ? (
              <DescriptionList
                items={[
                  { term: 'API base URL', description: query.data.apiBaseUrl },
                  { term: 'Account', description: query.data.account },
                  { term: 'Sender code', description: query.data.senderCode },
                  { term: 'Prefix', description: query.data.prefix },
                  { term: 'Username', description: query.data.username },
                ]}
              />
            ) : null}
            <Text as="p" variant="bodySm" tone="subdued">
              Edits require environment variable changes and a redeploy.
            </Text>
          </BlockStack>
        </Card>
        <TntTestConnectionCard />
      </BlockStack>
    </Page>
  );
}
